import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './footer.css'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faGithub} from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h4>Contact Us</h4>
            <p>Email: kennydangote893@gmail.com</p>
            <p>Phone: +254-757-4486-51</p>
          </div>
          <div className="col-md-4">
            <h4>Follow Us:</h4>
            <ul className="social-icons">
              <li>
                <a href="https://www.facebook.com/kennedy.wanakacha.98/">
                  <FontAwesomeIcon icon={faFacebook} /> Facebook
                </a>
              </li> <br />
              <li>
                <a href="/https://twitter.com/wanakachaa">
                <FontAwesomeIcon icon={faTwitter} /> Twitters
                </a>
              </li> <br />
              <li>
                <a href="https://www.instagram.com/__dangoo_/">
                <FontAwesomeIcon icon={faInstagram} /> Instagram
                </a>
              </li> <br />
              <li>
                <a href="https://github.com/Dangoo2002">
                <FontAwesomeIcon icon={faGithub} /> Github
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <h4>About Us:</h4>
            <p>Dangoo Rental System, developed by Kennedy Wanakacha, simplifies property management. With main offices in Juja, this innovative platform modernizes the rental process for landlords and tenants.</p>
            
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div className='ff'>
      <p>&copy; Kennedy Wanakacha.</p>

       </div>
    </footer>
  );
}

export default Footer;
